import {
  Button,
  Icon,
  IconName,
  Modal,
  Stack,
  Text,
} from "@fidelix/fx-miranda";
import { Trans } from "@lingui/react/macro";
import styled from "styled-components";

type Props = {
  onClose: () => void;
  onContinue: () => void;
  title: string;
  text: string;
  icon?: IconName;
  errorText?: string;
  isPending?: boolean;
  disableContinueButton?: boolean;
};
export function GenericModal({
  onClose,
  onContinue,
  title,
  text,
  icon,
  errorText,
  isPending,
  disableContinueButton,
}: Props) {
  return (
    <Modal onClose={onClose} placement="middle">
      <ModalWrapper>
        <Modal.Body>
          <Stack axis="y" spacing="large" align="center">
            <Icon icon={icon ?? "attentionFilled"} size={48} color="primary" />
            <Text variant="title2Bold">{title}</Text>
            <Text variant="bodyLight">{text}</Text>
            {errorText && (
              <Text variant="bodyLight" color="error">
                {errorText}
              </Text>
            )}
          </Stack>
        </Modal.Body>
      </ModalWrapper>
      <Modal.Footer>
        <Stack spacing="normal" justify="center">
          <Button isDisabled={isPending} variant="secondary" onPress={onClose}>
            <Trans>Cancel</Trans>
          </Button>
          <Button
            isDisabled={disableContinueButton || isPending}
            isLoading={isPending}
            iconPlacement="left"
            onPress={onContinue}
          >
            <Trans>Continue</Trans>
          </Button>
        </Stack>
      </Modal.Footer>
    </Modal>
  );
}
const ModalWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22.5vw;
  height: 25vh;
  min-width: 500px;
  min-height: 250px;
  text-align: center;
`;
